/**
 * Avatar configuration for user profiles.
 *
 * Avatars are generated client-side using DiceBear (adventurer-neutral style).
 * Only the integer index (1–20) is stored in Firebase — seeds never touch the database.
 * Avatar 0 = letter fallback (first letter of username on a pastel background).
 *
 * To swap an avatar, just change its seed here. The stored integer stays the same.
 *
 * Avatars by DiceBear (https://dicebear.com), adventurer-neutral style,
 * licensed under CC BY 4.0 (https://creativecommons.org/licenses/by/4.0/)
 */

export const AVATAR_SEEDS = [
  null,        // 0 — letter fallback, no DiceBear
  'George',    // 1
  'pebbly',    // 16
  'Jade',      // 3
  'Paula',      // 4
  'Jessica',    // 5
  'Alqu',     // 6
  'Sara',      // 7
  'aurora',    // 8
  'jasper',    // 9
  'Mason',     // 10
  'Eden',     // 11
  'Emery',     // 12
  'forest',    // 2
  'Wyattd',     // 13
  'Valentina',    // 14
  'Oliver',    // 15
  'bear',      // 17
  'solei',    // 18
  'Sca',      // 19
  'Mcrble',    // 20
];

export const AVATAR_COUNT = 20; // valid range: 1–20
